import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

const CLASSNAMES = {
  h: style.tooltip_horizontal,
  v: style.tooltip_vertical,
};
export function LabelTooltip({labelStyle, label, orientation}) {
  const className = CLASSNAMES[orientation];

  return (
    <div className={`${className} tooltip_horizontal`} style={labelStyle}>
      <p>{label}</p>
    </div>
  );
}

LabelTooltip.propTypes = {
  /**
   * Style for the label
   */
  labelStyle: PropTypes.object,
  /**
   * Label to display on tooltip
   */
  label: PropTypes.string,
  /**
   * To display the tooltip in horizontal[h]/veritcal[v] orientation
   */
  orientation: PropTypes.oneOf(['h', 'v']),
};

LabelTooltip.defaultProps = {
  labelStyle: {},
  orientation: 'h',
};
